const MAX_ZINDEX = 100000;

export const ZINDEX = {
  ROUTE_POINT: MAX_ZINDEX,
  ROUTE: MAX_ZINDEX - 1,
  USER_LOCATION: MAX_ZINDEX - 2,
  CARTOGRAM: MAX_ZINDEX - 3,
};
